exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-modal-header{overflow:hidden!important}.userinfo{text-align:center;float:left;overflow:hidden;position:absolute}.userinfo .hand-photo{float:left;width:25px;height:25px;border-radius:50%;background:#ccc;color:#fff;font-size:25px;overflow:hidden;line-height:25px;text-indent:-4px;letter-spacing:-4px}.userinfo .p1,.userinfo .p2{margin-left:10px;display:block;float:left;line-height:25px}.userinfo .p2{color:#b2b2b2}.ivu-col{padding-top:10px;padding-bottom:10px}.input-number-append{color:#a3a3a3!important;display:inline-block;font-size:16px;text-indent:5px}.ivu-form-item{margin-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dialysisProcess/dialysisArea/dialysisOff.vue
// module id = c04k
// module chunks = 0